export const AWSM_VALID_SESSION_COOKIE_NAME = "awsm-valid-session";
export const AEA_PLUGIN_PRESENT_COOKIE_NAME = "aea_plugin_present";
export const CLIENT_ID = "aws-navatar";
export const DEFAULT_LOCALE = "en-US";
export const DefaultLabels = {
    header: "Profile",
    subheader: "Your profile helps improve your interactions with select AWS experiences.",
    profileButtonText: "View profile",
    logOutText: "Log out",
    logInText: "Log in",
    createProfileText: "Create profile",
    federateLoginModalTitle: "Use Midway to access your AWS Profile",
    federateLoginModalFirstDescription: "As an Amazon employee, we recommend using Midway to access your AWS Profile. This security-recommended method provides seamless integration with internal systems.",
    federateLoginModalSecondDescription: "You're seeing this message because you've logged in with an Amazon email address using AWS Builder ID. This prompt will appear each time you log in until you switch to Midway or choose to continue with your current login.",
    federateLoginModalPrimaryButton: "Sign in with Midway",
    federateLoginModalSecondaryButton: "Continue with AWS Builder ID",
};
export const DefaultUrls = {
    profileUrl: "https://aws.amazon.com/profile",
    signOutUrl: "https://auth.aws.amazon.com/sign-out",
    signInUrl: "https://auth.aws.amazon.com/sign-in",
};
export var InteractableElements;
(function (InteractableElements) {
    InteractableElements["PROFILE"] = "profile";
    InteractableElements["LOG_OUT"] = "log-out";
    InteractableElements["LOG_IN"] = "log-in";
    InteractableElements["CREAETE_PROFILE"] = "create-profile";
})(InteractableElements || (InteractableElements = {}));
export var Themes;
(function (Themes) {
    Themes["LIGHT"] = "light";
    Themes["DARK"] = "dark";
})(Themes || (Themes = {}));
export var EnvironmentStage;
(function (EnvironmentStage) {
    EnvironmentStage["DEV"] = "dev";
    EnvironmentStage["ALPHA"] = "alpha";
    EnvironmentStage["BETA"] = "beta";
    EnvironmentStage["GAMMA"] = "gamma";
    EnvironmentStage["PROD"] = "prod";
    EnvironmentStage["UNKNOWN"] = "unknown";
})(EnvironmentStage || (EnvironmentStage = {}));
export var ProfileUrls;
(function (ProfileUrls) {
    ProfileUrls["GAMMA"] = "https://aws-mktg-site-hz-stg-gamma.amazon.com/profile";
    ProfileUrls["PROD"] = "https://aws.amazon.com/profile";
})(ProfileUrls || (ProfileUrls = {}));
//# sourceMappingURL=constants.js.map